import {create} from 'zustand';
import {PSPType, WalletTransactionsResponse} from './types';
import {downloadAccountStatement, listWalletTransactions} from './ApiHelper';
import {getStorageItem, putStorageItem, StorageKeys} from './StorageHelper';
import {startOfDay, startOfMonth, startOfQuarter, startOfWeek, startOfYear} from 'date-fns';

export interface LedgerState {
  loading: boolean;
  walletResponse: WalletTransactionsResponse;
  hasErrors: boolean;
  psp: PSPType;
  setPsp: (psp: PSPType) => Promise<void>;
  refresh: (force?: boolean) => void;
  downloadAccountStatement: () => Promise<any>;
  reset(): void;
}

async function getStateDate() {
  const since = await getStorageItem(StorageKeys.UI_LEDGER_SINCE);
  let startDate;
  if (since === 'quarter') {
    startDate = startOfQuarter(new Date());
  } else if (since === 'year') {
    startDate = startOfYear(new Date());
  } else if (since === 'month') {
    startDate = startOfMonth(new Date());
  } else if (since === 'week') {
    startDate = startOfWeek(new Date());
  } else if (since === 'day') {
    startDate = startOfDay(new Date());
  }
  else if(since === 'custom') {
    startDate = new Date(await getStorageItem(StorageKeys.UI_LEDGER_START_DATE));
  }
  return startDate;
}

async function getEndDate() {
  const since = await getStorageItem(StorageKeys.UI_LEDGER_SINCE);
  let endDate = new Date();
  if(since === 'custom') {
    endDate = new Date(await getStorageItem(StorageKeys.UI_LEDGER_END_DATE));
  }
  return endDate;
}

async function getStatePsp() {
  const psp = await getStorageItem(StorageKeys.UI_LEDGER_PSP);
  return psp;
}

const UseLedgerStore = create<LedgerState>((set) => {
  return {
    loading: true,
    walletResponse: null,
    hasErrors: false,
    psp: '',
    setPsp: async (psp: PSPType) => {
      await putStorageItem(StorageKeys.UI_LEDGER_PSP, psp);
    },
    downloadAccountStatement: async () => {
      let startDate = await getStateDate();
      let endDate = await getEndDate();
      return downloadAccountStatement(startDate, endDate);
    },
    refresh: async () => {
      set(() => ({loading: true}));
      try {
        let startDate = await getStateDate();
        let endDate = await getEndDate();
        let psp = await getStatePsp();
        const walletResponse = await listWalletTransactions(startDate, endDate, psp);
        set(() => ({walletResponse, loading: false, hasErrors: false, psp}));
      } catch (err: any) {
        set(() => ({walletResponse: null, loading: false, hasErrors: true}));
        throw err;
      }
    },
    reset: () => {
      set(() => ({
        loading: false,
        walletResponse: null,
        hasErrors: false,
      }));
    },
  };
});

export default UseLedgerStore;
